import {Injectable} from '@angular/core';
import {SwPush} from '@angular/service-worker';
import {ServiceApi} from '../../network/service/service.api';
import {DataResponse} from '../../network/service/data.response';

@Injectable({providedIn: 'root'})
export class NotificationService {

  constructor(private swPush: SwPush, private serviceApi: ServiceApi) {
  }

  subscribeToNotifications() {
    if (!this.swPush.isEnabled) return;

    if (typeof Notification !== 'undefined' && Notification.permission === 'denied') {
      return;
    }

    navigator.serviceWorker.ready.then(reg => {
      reg.pushManager.getSubscription().then(sub => {
        this.serviceApi.getDomainDetail().subscribe((res: DataResponse<any>) => {
          if (!res?.success) return;

          const domain = res.data;
          const publicKey: string | undefined = domain?.Details?.VapidDetails?.PublicKey;
          if (!publicKey) return;

          const cacheKey = 'webpush_vapid_public_key';
          const cachedKey = localStorage.getItem(cacheKey);
          const keyChanged = !!cachedKey && cachedKey !== publicKey;

          const syncToServer = (finalSub: PushSubscription) => {
            localStorage.setItem(cacheKey, publicKey);

            this.serviceApi.subscribe(finalSub).subscribe({
              next: () => {
              },
              error: () => {
              }
            });
          };

          const doSubscribe = () => {
            this.swPush.requestSubscription({serverPublicKey: publicKey})
              .then(newSub => syncToServer(newSub))
              .catch(() => {
              });
          };

          if (sub && !keyChanged) {
            if (!cachedKey) localStorage.setItem(cacheKey, publicKey);
            syncToServer(sub);
            return;
          }

          if (sub && keyChanged) {
            sub.unsubscribe()
              .then(() => doSubscribe())
              .catch(() => doSubscribe());
            return;
          }

          doSubscribe();
        });
      });
    });
  }
}
